import { detect } from 'detect-browser'
const browser = detect() || {}
// const ua = window.navigator.userAgent.toLowerCase();
// const md = new MobileDetect(ua);
// const os = md.os();//获取系统
// const mobile = md.mobile();
// const os_detail = ua.substring(ua.indexOf('(') + 1, ua.indexOf(')'))
// const is_mobile = (ua.match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) !== null)

export function device(){
  const device = {
    entry: 'PC_browser',
    name: browser.name || '',
    version: browser.version || '',
    os: browser.os || 'chrome'
  }
  // app
  // if(device.entry === 'app') {
  //   if(!window.api){
  //     console.error('window.api is null')
  //     // return
  //   }
  //   device['App_version'] = window.api.appVersion;
  //   device['App_deviceModel'] = window.api.systemType + "--" + window.api.deviceModel;
  //   device['App_deviceId'] = window.api.deviceId;
  //   device['App_netWorkType'] = window.api.connectionType;
  //   device['App_screen'] = window.api.screenWidth + '*' + window.api.screenHeight;
  //   device['App_operator'] = window.api.operator;
  //   device['App_systemVersion'] =window.api.systemType + "--" + window.api.systemVersion;
  // }else {
  //   device['H5_os'] = os;
  //   device['H5_os_detail'] = os_detail;
  //   device['H5_mobile'] = mobile;
  // }
  // const ENV = {
  //   app: device.entry === 'app',
  //   dd: device.entry === 'dd',
  //   wx: device.entry === 'wx',
  //   wxwork: device.entry === 'wxwork',
  //   wx_miniProgram: device.entry === 'wx_miniProgram',
  //   feishu: device.entry === 'feishu',
  //   other: device.entry === 'H5_browser' || device.entry === 'H5_webview' || device.entry === 'PC_browser'
  // }
  // device.env = ENV;
  return device
}
